import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Signup from './components/Signup';
import MainPage from './components/MainPage';
import './App.css';

function App() {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('currentUser')) || null);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login setUser={setUser} />} />
        <Route path="/signup" element={<Signup setUser={setUser} />} />
        <Route path="/main" element={user ? <MainPage user={user} setUser={setUser} /> : <Login setUser={setUser} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;